import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const menuItems = [
  { path: '/dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', label: 'ダッシュボード' },
  { path: '/notifications', icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9', label: '通知' },
  { path: '/requests', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01', label: '要請応対', permission: 'requests.view' },
  { path: '/constructions', icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z', label: '工事管理', permission: 'constructions.view' },
  { path: '/billing-invoices', icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z', label: '請求書管理', permission: 'billing_invoices.view' },
  { path: '/companies', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4', label: '企業管理', permission: 'companies.view' },
  { path: '/talkrooms', icon: 'M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z', label: 'トークルーム', permission: 'talkrooms.view' },
  { path: '/calendar', icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z', label: 'カレンダー', permission: 'calendar.view' },
  { path: '/tasks', icon: 'M4 6h16M4 10h16M4 14h16M4 18h16', label: 'タスク管理', permission: 'tasks.view' },
  { path: '/daily-reports', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', label: '日報管理', permission: 'daily_reports.view' },
  { path: '/board', icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z', label: '掲示板', permission: 'board.view' },
  { path: '/users', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z', label: 'ユーザー管理', permission: 'users.view' },
  { path: '/payslips', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', label: '給与明細', permission: 'payslips.view' },
  { path: '/incentive-statements', icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z', label: 'インセンティブ明細', permission: 'incentives.view' },
  { path: '/year-end-adjustment', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4', label: '年末調整', permission: 'year_end.view' },
  { path: '/surveys', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4', label: 'アンケート', permission: 'surveys.view' },
];

const masterItems = [
  { path: '/masters/areas', label: 'エリア' },
  { path: '/masters/departments', label: '部署' },
  { path: '/masters/positions', label: '役職' },
  { path: '/masters/categories', label: 'カテゴリ' },
  { path: '/masters/statuses', label: 'ステータス' },
  { path: '/masters/clientTypes', label: '取引先種別' },
  { path: '/masters/products', label: '商品（商材）' },
  { path: '/masters/powerCompanies', label: '電力会社' },
  { path: '/masters/constructionPartners', label: '施工パートナー' },
  { path: '/masters/demandLocations', label: '需要場所' },
  { path: '/masters/contractTypes', label: '契約種別' },
  { path: '/masters/constructionTypes', label: '工事種別' },
  { path: '/masters/facilityTypes', label: '設備種別' },
];

const adminItems = [
  { path: '/admin/roles', label: 'ロール管理' },
  { path: '/admin/permissions', label: '権限マトリックス' },
  { path: '/admin/incentive-settings', label: 'インセンティブ設定' },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function Sidebar({ isOpen, onClose }: SidebarProps) {
  const { user } = useAuth();
  const isAdmin = user?.roleCode === 'admin';
  const isPromoter = user?.roleCode === 'promoter' || isAdmin;
  const [isMasterOpen, setIsMasterOpen] = useState(false);

  // ユーザーが特定の権限を持っているかチェック
  const hasPermission = (permission?: string): boolean => {
    if (!permission) return true; // 権限指定がない場合は表示
    if (!user?.permissions) return false;
    return user.permissions.includes(permission);
  };

  // 権限に基づいてメニュー項目をフィルタリング
  const visibleMenuItems = menuItems.filter(item => hasPermission(item.permission));

  const handleNavClick = () => {
    // モバイルではナビゲーション時にサイドバーを閉じる
    if (window.innerWidth < 768) {
      onClose();
    }
  };

  return (
    <>
      {/* オーバーレイ（モバイル時のみ表示） */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      {/* サイドバー */}
      <aside
        className={`
          fixed left-0 top-0 w-[200px] h-screen flex flex-col z-50
          transform transition-transform duration-300 ease-in-out
          md:translate-x-0
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
        style={{ backgroundColor: 'var(--background-aside-primary)' }}
      >
        {/* ロゴ */}
        <div className="h-16 flex items-center justify-center border-b border-white/10 px-4 bg-white">
          <img src="/sekaie-logo-full.png" alt="セカイエ" className="h-9 object-contain" />
        </div>

        {/* メニュー */}
        <nav className="flex-1 overflow-y-auto py-4">
          <ul className="space-y-1 px-2">
            {visibleMenuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  onClick={handleNavClick}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                      isActive
                        ? 'bg-white/20 text-white'
                        : 'text-white/80 hover:bg-white/10 hover:text-white'
                    }`
                  }
                >
                  <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                  </svg>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>

          {/* マスタ管理 */}
          {isPromoter && hasPermission('masters.view') && (
            <div className="mt-6">
              <button
                onClick={() => setIsMasterOpen(!isMasterOpen)}
                className="w-full px-4 py-2 flex items-center justify-between text-xs font-semibold text-white/50 uppercase tracking-wider hover:bg-white/5 transition-colors"
              >
                <span>マスタ管理</span>
                <svg
                  className={`w-4 h-4 transition-transform duration-200 ${isMasterOpen ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isMasterOpen && (
                <ul className="space-y-0.5 px-2 mt-1">
                  {masterItems.map((item) => (
                    <li key={item.path}>
                      <NavLink
                        to={item.path}
                        onClick={handleNavClick}
                        className={({ isActive }) =>
                          `block px-3 py-1.5 rounded text-xs transition-colors ${
                            isActive
                              ? 'bg-white/20 text-white'
                              : 'text-white/70 hover:bg-white/10 hover:text-white'
                          }`
                        }
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {/* 管理者メニュー */}
          {isAdmin && (
            <div className="mt-6">
              <div className="px-4 text-xs font-semibold text-white/50 uppercase tracking-wider mb-2">
                システム管理
              </div>
              <ul className="space-y-0.5 px-2">
                {adminItems.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      onClick={handleNavClick}
                      className={({ isActive }) =>
                        `block px-3 py-1.5 rounded text-xs transition-colors ${
                          isActive
                            ? 'bg-white/20 text-white'
                            : 'text-white/70 hover:bg-white/10 hover:text-white'
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </nav>
      </aside>
    </>
  );
}
